import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { LightEllipse, BlueRightWave, Warning } from 'src/assets';
import './tradingPeriod.scss';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const TradingPeriod = () => {
  const { t } = useTranslation();

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  const renderRow = useCallback(
    (title, sub) => {
      return (
        <tr>
          <th>{t(title)}</th>
          <td>
            <text>{t(sub)}</text>
          </td>
        </tr>
      );
    },
    [t],
  );

  return (
    <>
      <div className="wave">
        <div className="wave-content">
          <img src={BlueRightWave} alt={BlueRightWave} />
        </div>
      </div>
      <div className="trading-period">
        <div className={`trading-period-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
          <div className="trading-period-title">
            <supertitle>{t('tradingPeriod:supertitle')}</supertitle>
            <h1 className="trading-period-heading">
              <black-underline>{t('tradingPeriod:trading')}</black-underline>{' '}
              {t('tradingPeriod:session')}
            </h1>
            <text>{t('tradingPeriod:subtitle')}</text>
          </div>
          <div className="trading-period-table-wrapper">
            <table className="trading-period-table">
              <tbody>
                {renderRow('tradingPeriod:europeTitle', 'tradingPeriod:europeTime')}
                {renderRow('tradingPeriod:usaTitle', 'tradingPeriod:usaTime')}
                {renderRow('tradingPeriod:indexTitle', 'tradingPeriod:indexTime')}
                {renderRow('tradingPeriod:rawTitle', 'tradingPeriod:rawTime')}
                {renderRow('tradingPeriod:forexTitle', 'tradingPeriod:forexTime')}
                {renderRow('tradingPeriod:cryptoTitle', 'tradingPeriod:cryptoTime')}
              </tbody>
            </table>
          </div>
          <div className="trading-period-warning">
            <img src={Warning} alt={Warning} />
            <text>{t('tradingPeriod:timeFormat')}</text>
          </div>

          <img src={LightEllipse} alt={LightEllipse} className="trading-period-image-1" />
        </div>
      </div>
    </>
  );
};
